import { colorScales } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { iconStyle, type LiveStatusIconSize } from "../LiveAppIcons";
export function HealthyIcon(size: LiveStatusIconSize) {
    return (<span className={iconStyle(size)} style={{ background: colorScales.green[500] }}>
            <em className="fa-solid fa-heart"/>
        </span>);
}
